export default __webpack_public_path__ + "static/media/c5.f5828030.png";